<template>
  <section id="parent">
    <app-menu-panel></app-menu-panel>
    <app-header />
    <main>
      <router-view />
    </main>
    <!-- <app-footer /> -->
  </section>
  <app-menu-bar></app-menu-bar>
  <!-- <p style="text-align: center; position: fixed; bottom:0">モード（開発用）: {{ Config.APP_MODE }}</p> -->
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import MenuBar from '@/components/menu/MenuBar.vue'
import MenuPanel from "@/components/menu/MenuPanel.vue";
import Config from '@/const/Config';

export default defineComponent({
  setup() {
    return { Config }

  },
  components: {
    'app-header': Header,
    'app-footer': Footer,
    'app-menu-bar': MenuBar,
    'app-menu-panel': MenuPanel
  }
})
</script>
